export default "__VITE_PUBLIC_ASSET__a5560471__"